"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _ = require("../..");
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
var _Permissions = require("../../constants/Permissions");
var _useHotKeys = require("../../hooks/useHotKeys");
var _propComparators = require("../../utils/propComparators");
var _SourceListItemHeader = _interopRequireDefault(require("./SourceListItemHeader"));
var _SourceListNetworkInfo = _interopRequireDefault(require("./SourceListNetworkInfo"));
var _SourceListItemBody = _interopRequireDefault(require("./SourceListItemBody"));
var _SourceListItemDnd = _interopRequireDefault(require("./SourceListItemDnd"));
var _SourceListItemWrapper = _interopRequireDefault(require("./SourceListItemWrapper"));
var _SourceListItem = require("./SourceListItem.styled");
var _SourceListItemPropTypes = require("./SourceListItemPropTypes");
var _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var getViewPermissions = function getViewPermissions() {
  return [_Permissions.REORDER_SOURCES];
};
var SourceListItem = function SourceListItem(_ref) {
  var index = _ref.index,
    enableFeature = _ref.enableFeature,
    dragAndDrop = _ref.dragAndDrop,
    source = _ref.source,
    onLiveClicked = _ref.onLiveClicked,
    onMuteToggleClicked = _ref.onMuteToggleClicked,
    onSourceEdited = _ref.onSourceEdited,
    onSourceDeleted = _ref.onSourceDeleted,
    onSourceHidden = _ref.onSourceHidden,
    onFeaturedToggleClicked = _ref.onFeaturedToggleClicked,
    onLiveToggleClicked = _ref.onLiveToggleClicked,
    onLoopToggleClicked = _ref.onLoopToggleClicked,
    onVolumeChanged = _ref.onVolumeChanged,
    live = _ref.live,
    loop = _ref.loop,
    volume = _ref.volume,
    isMuted = _ref.isMuted,
    onCameraToggleClicked = _ref.onCameraToggleClicked,
    isCameraOn = _ref.isCameraOn,
    isMaximumCameraSourcesOn = _ref.isMaximumCameraSourcesOn,
    _ref$isStaged = _ref.isStaged,
    isStaged = _ref$isStaged === void 0 ? false : _ref$isStaged,
    onSourceStaged = _ref.onSourceStaged,
    isStagedSourcesActive = _ref.isStagedSourcesActive,
    onReorderSources = _ref.onReorderSources,
    onDragSource = _ref.onDragSource,
    isDraggingSource = _ref.isDraggingSource,
    onThumbnailReady = _ref.onThumbnailReady,
    onUploadClicked = _ref.onUploadClicked,
    prevSource = _ref.prevSource,
    onSetSourceUnassigned = _ref.onSetSourceUnassigned,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions,
    attendeeTiles = _ref.attendeeTiles,
    meetingSession = _ref.meetingSession,
    isDirectorSource = _ref.isDirectorSource,
    onPdfAssignClicked = _ref.onPdfAssignClicked,
    onAssignSpeakers = _ref.onAssignSpeakers,
    onReplaceSlides = _ref.onReplaceSlides,
    onPresentationLoadSuccess = _ref.onPresentationLoadSuccess,
    onGoToPresentationPage = _ref.onGoToPresentationPage,
    layout = _ref.layout;
  var value = source.value;
  var showNetworkHealthMonitoringStats = (0, _.shouldHaveFeature)('studio.networkHealthMonitoringStats');
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hover = _useState2[0],
    setHover = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isTooltipVisible = _useState4[0],
    setIsTooltipVisible = _useState4[1];
  var sourceHandler = enableFeature ? onLiveClicked : function () {};
  var keys = getSoloSourceHotkey(source.type, index + 1);
  (0, _useHotKeys.useHotKeys)(keys, sourceHandler);
  var handleOnFeaturedToggleClicked = (0, _react.useCallback)(function () {
    setIsTooltipVisible(false);
    onFeaturedToggleClicked();
  }, [setIsTooltipVisible, onFeaturedToggleClicked]);
  var handleOnMuteToggleClicked = (0, _react.useCallback)(function () {
    setIsTooltipVisible(false);
    onMuteToggleClicked();
  }, [setIsTooltipVisible, onMuteToggleClicked]);
  var handleOnLoopToggleClicked = (0, _react.useCallback)(function () {
    setIsTooltipVisible(false);
    onLoopToggleClicked();
  }, [setIsTooltipVisible, onLoopToggleClicked]);
  var handleOnCameraToggleClicked = (0, _react.useCallback)(function () {
    setIsTooltipVisible(false);
    onCameraToggleClicked();
  }, [setIsTooltipVisible, onCameraToggleClicked]);
  var handleOnSourceStaged = (0, _react.useCallback)(function () {
    setIsTooltipVisible(false);
    onSourceStaged();
  }, [setIsTooltipVisible, onSourceStaged]);
  var handleOnLiveClicked = (0, _react.useCallback)(function () {
    setIsTooltipVisible(false);
    onLiveClicked();
  }, [setIsTooltipVisible, onLiveClicked]);
  var toggleTooltipVisibilityOn = (0, _react.useCallback)(function () {
    setIsTooltipVisible(true);
  }, [setIsTooltipVisible]);
  var onHoverOn = function onHoverOn() {
    return setHover(true);
  };
  var onHoverOff = function onHoverOff() {
    return setHover(false);
  };
  var handleBlur = function handleBlur(e) {
    var _e$target, _popOverElement$conta;
    var id = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.id;
    var popOverElement = document.querySelector('#popover');
    var insidePopOverClick = (_popOverElement$conta = popOverElement === null || popOverElement === void 0 ? void 0 : popOverElement.contains(e.target)) !== null && _popOverElement$conta !== void 0 ? _popOverElement$conta : false;
    // If the click is inside the popover or on the element that opens the popover, do not remove focus
    if (id === 'goToSlideNumberSelector' || insidePopOverClick) {
      return;
    }
    if (!e.currentTarget.contains(e.relatedTarget)) {
      onHoverOff();
    }
  };
  var SourceItem = dragAndDrop && enableFeature ? _SourceListItemDnd["default"] : _SourceListItemWrapper["default"];
  var testId = "source-".concat(source.title, "-").concat(source.type);
  var showDivider = (0, _react.useMemo)(function () {
    return prevSource && (prevSource === null || prevSource === void 0 ? void 0 : prevSource.type) === _.SCREEN_PRESENTER && (source === null || source === void 0 ? void 0 : source.type) === _.CAMERA_PRESENTER;
  }, [prevSource, source]);
  var displayComponentHeader = (0, _react.useCallback)(function () {
    return _react["default"].createElement(_SourceListItemHeader["default"], {
      source: source,
      onSourceDeleted: onSourceDeleted,
      onSourceEdited: onSourceEdited,
      onSourceHidden: onSourceHidden,
      live: live,
      isStaged: isStaged,
      hover: hover,
      onSetSourceUnassigned: onSetSourceUnassigned,
      user: user,
      viewPermissions: viewPermissions,
      isDirectorSource: isDirectorSource,
      onAssignSpeakers: onAssignSpeakers,
      onReplaceSlides: onReplaceSlides,
      onGoToPresentationPage: onGoToPresentationPage
    });
  }, [source, onSourceDeleted, onSourceEdited, onSourceHidden, live, isStaged, hover, onSetSourceUnassigned]);
  var displayComponentBody = (0, _react.useCallback)(function () {
    return _react["default"].createElement(_SourceListItemBody["default"], {
      "data-testid": "relative-container",
      source: source,
      live: live,
      hover: hover,
      loop: loop,
      volume: volume,
      isMuted: isMuted,
      isStaged: isStaged,
      isCameraOn: isCameraOn,
      isDraggingSource: isDraggingSource,
      isStagedSourcesActive: isStagedSourcesActive,
      isMaximumCameraSourcesOn: isMaximumCameraSourcesOn,
      onVolumeChanged: onVolumeChanged,
      onThumbnailReady: onThumbnailReady,
      onUploadClicked: onUploadClicked,
      onLiveToggleClicked: onLiveToggleClicked,
      isTooltipVisible: isTooltipVisible,
      onFeaturedToggleClicked: handleOnFeaturedToggleClicked,
      onMuteToggleClicked: handleOnMuteToggleClicked,
      onLoopToggleClicked: handleOnLoopToggleClicked,
      onCameraToggleClicked: handleOnCameraToggleClicked,
      onSourceStaged: handleOnSourceStaged,
      onLiveClicked: handleOnLiveClicked,
      toggleTooltipVisibilityOn: toggleTooltipVisibilityOn,
      user: user,
      viewPermissions: viewPermissions,
      attendeeTiles: attendeeTiles,
      meetingSession: meetingSession,
      onPdfAssignClicked: onPdfAssignClicked,
      onPresentationLoadSuccess: onPresentationLoadSuccess,
      onGoToPresentationPage: onGoToPresentationPage,
      onSourceDeleted: onSourceDeleted,
      layout: layout
    });
  }, [source, live, hover, loop, volume, isMuted, isStaged, isCameraOn, isDraggingSource, isStagedSourcesActive, isMaximumCameraSourcesOn, onVolumeChanged, onThumbnailReady, onUploadClicked, onLiveToggleClicked, isTooltipVisible, handleOnFeaturedToggleClicked, handleOnMuteToggleClicked, handleOnLoopToggleClicked, handleOnCameraToggleClicked, handleOnSourceStaged, handleOnLiveClicked, toggleTooltipVisibilityOn, onPresentationLoadSuccess, onGoToPresentationPage]);
  var displaySourceListItem = function displaySourceListItem() {
    return _react["default"].createElement(_SourceListItem.SourceListItemV2Wrapper, null, showDivider && _react["default"].createElement(_SourceListItem.SourceListItemV2Divider, {
      "data-testid": "source-divider"
    }), _react["default"].createElement(SourceItem, {
      $isV2: true,
      $canShowDivider: showDivider,
      source: source,
      index: index,
      dataTestId: testId,
      onReorderSources: onReorderSources,
      onDragSource: onDragSource
    }, _react["default"].createElement(_SourceListItem.SourceListItemSource, {
      tabIndex: "0",
      "data-testid": "event-source-wrapper",
      onMouseEnter: onHoverOn,
      onMouseLeave: onHoverOff,
      onFocus: onHoverOn,
      onBlur: function onBlur(e) {
        return handleBlur(e);
      }
    }, (source === null || source === void 0 ? void 0 : source.title) && displayComponentHeader(), (source === null || source === void 0 ? void 0 : source.title) && displayComponentBody())), showNetworkHealthMonitoringStats && source.type === 'cameraPresenter' && _react["default"].createElement(_SourceListNetworkInfo["default"], {
      attendeeId: value
    }));
  };
  var displayComponent = function displayComponent() {
    return displaySourceListItem();
  };
  return _react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayComponent.bind(_this),
    user: user,
    viewPermissions: viewPermissions
  });
};
var getSoloSourceHotkey = function getSoloSourceHotkey(sourceType, index) {
  if ([_.SCREEN_PRESENTER, _.CAMERA_PRESENTER].includes(sourceType)) {
    return "command+".concat(index, ",ctrl+").concat(index);
  }
  return "shift+command+".concat(index, ",shift+ctrl+").concat(index);
};
SourceListItem.propTypes = _SourceListItemPropTypes.SourceListItemPropTypes;
var _default = exports["default"] = (0, _react.memo)(SourceListItem, _propComparators.equalityComparator);